import React, { Component } from 'react';
import Header from './Header';
import Footer from './Footer';
import ProjectData, { projectData } from '../json_data/project.js';
import '../css/Project.css';
import {FadeTransform} from 'react-animation-components';
<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Roboto"></link>
//import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader  
//import { Carousel } from 'react-responsive-carousel';  

const Card=({data})=>{
  //console.log(props.desc);
  return(
    <div className="projectCard">
      <div class="image">
        <img src={data.image} width="280" height="192"/>
      </div>
      <div class="text">
        <div class="title">
          <h1>{data.name}</h1>
        </div>
        <figcaption>
          <h5>{data.description}</h5>
        </figcaption>
      </div>
      <div class="github-button">
        <button>
          <a className="btn text-white btn-floating m-1" style={{backgroundColor: "#333333"}} href={data.link} role="button"><i class="fa fa-github fa-lg"></i></a>
        </button>
      </div>
    </div>
  );

}
function Projects() {
  return (
    <div>
      <Header/>
      <FadeTransform
          in
          transformProps={{
              enterTransform: 'translateX(0px)',
              exitTransform: 'translateX(-100px)'
          }}
      >
      <div className="heading">
        Projects
      </div>
      <div className="project">
          {projectData.map((data,idx)=>(
            <Card data={data} key={idx}/>
          ))}
      </div>
      {/* <div class="slider">
        <div id="carouselExampleDark" class="carousel carousel-dark slide" data-bs-ride="carousel">
          <div class="carousel-indicators">
            <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
            <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="1" aria-label="Slide 2"></button>
            <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="2" aria-label="Slide 3"></button>
          </div>
          <div class="carousel-inner">


            <div class="carousel-item active" data-bs-interval="10000">
              <Card img={img1} desc={"Communication Buddy"} link={"https://github.com/devanshukd04/Communication-Buddy"}/>
            </div>
            <div class="carousel-item" data-bs-interval="2000">
              <Card img={img2} desc={"Sign Language Recognition"} link={"https://github.com/devanshukd04/Sign-Language-Detection"}/>
            </div>
            <div class="carousel-item">
              <Card img={img3} desc={"Face Mask Detection"} link={"https://github.com/devanshukd04/Face-mask-Detection"}/>
            </div>

          </div>
          <a class="carousel-control-prev" type="button" data-bs-target="#carouselExampleDark" data-bs-slide="prev">
            <span style={{ padding: "5px",color:"#121846" }} className="fa fa-chevron-left fa-lg"></span>{" "}
          </a>
          <a class="carousel-control-next" type="button" data-bs-target="#carouselExampleDark" data-bs-slide="next">
            <span style={{ padding: "5px",color:"#121846" }} className="fa fa-chevron-right fa-lg"></span>{" "}
          </a>
        </div>
      </div> */}
      </FadeTransform>
      <Footer/>
    </div>

  )
}

export default Projects;